export default ['FW Perspectives Live', 'IAV Live', 'Sponsor Event', 'Resource']
